import * as React from 'react';

import * as styles from './DesktopSearchFormLayout.css';
import clsx from 'clsx';

interface IDesktopSearchFormLayoutProps {
  isSearchPage: boolean;
  onSubmit?: (e: React.FormEvent) => void;
}

export const DesktopSearchFormLayout: React.FC<React.PropsWithChildren<IDesktopSearchFormLayoutProps>> = ({
  children,
  isSearchPage,
  onSubmit,
}) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit?.(e);
  };

  return (
    <form className={clsx(styles['form'], isSearchPage && styles['search-page'])} action="#" onSubmit={handleSubmit}>
      {children}
    </form>
  );
};
